export default "__VITE_ASSET__5fgAhVJH__";